export default "__VITE_ASSET__jDQHunUf__"